module.exports = __webpack_public_path__ + "img/code.ec69c047.svg";